import './Company.styles.scss'
import { useTranslation } from 'react-i18next'

export default function Company() {
    const { t } = useTranslation();
    
    return (
        <section id="company">
            <div className="title">
                <h2>Solvix</h2>
                <p>{t('company.tagline')}</p>
            </div>
            <div className="about"></div>
        </section>
    )
}
